import { PortType } from './portTypes';

/**
 * The media a media control, node row or saved binding takes. Absent is image, matching every
 * binding saved before typed media controls existed. One reader, so the node, the card, the runner
 * and the save boundary cannot disagree about whether a video binding takes an image.
 */
export function normalizeBindingMediaType(binding) {
  return binding?.mediaType === 'video' ? 'video' : 'image';
}

/**
 * What a media-entry param (`mediaEntries: true` on the node catalog) declares about the entries
 * it holds, stated once for every surface that draws or writes one: the node row, the workflow
 * card, the saved module's control. Which media (from the param's port type: video when declared
 * VIDEO, image otherwise) and, when declared, how many (`maxEntries`).
 */
export function getMediaEntryParamFacts(paramDef) {
  if (paramDef?.mediaEntries !== true) return null;
  return {
    mediaType: paramDef.type === PortType.VIDEO ? 'video' : 'image',
    ...(Number.isInteger(paramDef.maxEntries) ? { maxEntries: paramDef.maxEntries } : {}),
  };
}
